import { render, staticRenderFns } from "./BxTag.vue?vue&type=template&id=95acefd0&"
import script from "./BxTag.vue?vue&type=script&lang=js&"
export * from "./BxTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports